import { render, staticRenderFns } from "./AccordionGroup.vue?vue&type=template&id=70035c7e&scoped=true&lang=pug"
import script from "./AccordionGroup.vue?vue&type=script&lang=js"
export * from "./AccordionGroup.vue?vue&type=script&lang=js"
import style0 from "./AccordionGroup.vue?vue&type=style&index=0&id=70035c7e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70035c7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70035c7e')) {
      api.createRecord('70035c7e', component.options)
    } else {
      api.reload('70035c7e', component.options)
    }
    module.hot.accept("./AccordionGroup.vue?vue&type=template&id=70035c7e&scoped=true&lang=pug", function () {
      api.rerender('70035c7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/basic/AccordionGroup.vue"
export default component.exports